export var getAttributeValue = function (attributes, attributeKey) {
    if (attributes === void 0) { attributes = []; }
    if (attributes.length === 0) {
        return '';
    }
    var attribute = attributes
        .filter(function (a) {
        if (typeof a === 'string') {
            return a.indexOf(attributeKey + "|") === 0;
        }
        else {
            return a.key.toLowerCase() === attributeKey;
        }
    })[0];
    return (typeof attribute === 'string' ? attribute.split('|')[1] : attribute.value);
};
